import { render } from "./EducationContainer.vue?vue&type=template&id=66c4514f&lang=true"
import script from "./EducationContainer.vue?vue&type=script&lang=js"
export * from "./EducationContainer.vue?vue&type=script&lang=js"

import "./EducationContainer.vue?vue&type=style&index=0&id=66c4514f&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__